import RotateKeys from './RotateKeys';
import RotateKeystone from './RotateKeystone';
import PopulateHumanOpensearch from './PopulateHumanOpensearch';

const Admin = () => (
  <div>
    <section>
      <h1>Rotate Keys</h1>
      <RotateKeys />
    </section>
    <section>
      <h1>Rotate Keystone</h1>
      <RotateKeystone />
    </section>
    <section>
      <h1>Populate Human Opensearch</h1>
      <PopulateHumanOpensearch />
    </section>
  </div>
);

export default Admin;
